// src/utils/localStorage.js
const LocalStorage = {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key) {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  },
  remove(key) {
    localStorage.removeItem(key);
  },
  clear() {
    localStorage.clear();
  }
};

// 定义所有 key 的常量
export const LocalStorageKeys = {
  USER_INFO: '_',
  COUNTDOWN_KEY: 'vip_countdown_target'
};

export default LocalStorage;



// WEBPACK FOOTER //
// ./src/utils/local_storage.js